import React from 'react';
import { Link, useWindowSize } from 'vindi-ds-components';
import Header from '@templates/header';

function HeaderCustomerNew() {
  const { isMobile } = useWindowSize();

  return isMobile ? (
    <Header.Mobile
      links='/admin/customers'
      title='Novo cliente'
    />
  ) : (
    <Header.Default
      links={[
        <Link href='/admin/customers'>Clientes</Link>,
      ]}
      title='Novo cliente'
    />
  );
}

export default HeaderCustomerNew;
